export default "__VITE_ASSET__BebO13so__"